/* eslint-disable import/prefer-default-export */
import {
  checkJarvisIsAdActive,
  isValidProperty,
  isCurrentAdActiveSS,
} from 'helpers/ads/utils';
import makeRequest from 'utils/makeRequest';
import reducerRegistry from '../../reduxUtils/reducerRegistry';
import { getJarvisFeedURL } from '../../utils/common';

const reducerName = 'miniTv';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const RECIEVE_MINITV_DATA = createActionName('RECIEVE_MINITV_DATA');
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');
export const SHOW_MINITV_PLAYER = createActionName('SHOW_MINITV_PLAYER');
export const CLOSE_MINITV_PLAYER = createActionName('CLOSE_MINITV_PLAYER');

export function showMiniTvPlayer(isShown) {
  return {
    type: SHOW_MINITV_PLAYER,
    payload: {
      showMiniTv: isShown,
    },
  };
}
export function hideAnimation() {
  return {
    type: CLOSE_MINITV_PLAYER,
    payload: {
      isActiveFrom: 'noMiniTV',
    },
  };
}
function recieveMiniTvData(data) {
  return {
    type: RECIEVE_MINITV_DATA,
    payload: {
      ...data,
    },
  };
}
function handleDataError(error) {
  return {
    type: HANDLE_DATA_ERROR,
    payload: {
      isActiveFrom: 'noMiniTV',
      error,
    },
  };
}

function fetchMiniTvDataV2() {
  const url = `${getJarvisFeedURL(
    '/revenue/minitv_all/63cea19091d09710f394ae9c',
  )}`;
  return makeRequest.get(url, {}, 'skipfeedengine');
}

export function getMinitvConfig(mdata, props) {
  const { isWapView, layoutConfig = {}, jarvisLayoutConfig = {} } = props;

  if (mdata?.jmweb_setting && isWapView) {
    mdata = {
      ...mdata,
      ...mdata.jmweb_setting,
    };
  }
  const layoutConf = {
    ...layoutConfig,
    ...jarvisLayoutConfig,
  };
  if (!layoutConf.skipPageLvl) {
    return {
      ...mdata,
      ...layoutConf,
    };
  }
  return mdata;
}

function checkJarvis(conf, setting) {
  if (!conf) {
    return conf;
  }
  conf = getMinitvConfig(conf, setting);
  if (typeof window.checkJarvisIsAdActive === 'function') {
    return window.checkJarvisIsAdActive(conf);
  }
  const { isWapView, isUserPrime } = setting;
  const platform = isWapView ? 'mweb' : 'web';
  if (window.Times?.adsKeys) {
    const pageconf = { ...window.Times?.adsKeys, isWapView };
    const jsetting = isCurrentAdActiveSS(conf, pageconf);
    if (jsetting?.isAdActive === 0) {
      return null;
    }
  }
  if (isUserPrime && conf?.skipPrime) {
    return null;
  }
  return isValidProperty(conf?.platform, platform) ? conf : null;
}
export function loadMiniTv(setting) {
  const { unsticky } = setting;
  return dispatch => {
    let data = null;
    let isActiveFrom = 'noMiniTV';
    data = checkJarvisIsAdActive('minitv');
    const startloadingAssest = (mdata, from, videoEnable) => {
      if (mdata) {
        const isSickyClose = unsticky && mdata?.sticky;
        if (isSickyClose) {
          mdata.sticky = false;
        }
      }
      if (mdata || videoEnable) {
        dispatch(
          recieveMiniTvData({ data: mdata, isActiveFrom: from, videoEnable }),
        );
      }
    };
    if (data) {
      data = getMinitvConfig(data, setting);
    }
    startloadingAssest(data, 'jarvis', false);
    fetchMiniTvDataV2()
      .then(jdata => {
        const { promotional, editor, multipleMinitv } = jdata?.data || {};
        // And Editor will override all config
        if (editor?.videoId) {
          const isActive = checkJarvis(editor, setting);
          if (isActive && editor?.videoId) {
            data = editor;
            isActiveFrom = 'editor';
          }
        } else {
          if (multipleMinitv?.length) {
            // 2nd Priority Multiple minitv
            // eslint-disable-next-line no-restricted-syntax
            for (const minitv of multipleMinitv) {
              const isActive = checkJarvis(minitv, setting);
              if (isActive && minitv?.videoId) {
                data = minitv;
                isActiveFrom = 'jarvis';
                break;
              }
            }
          }
          if (promotional?.videoId) {
            // At Last  Promotional Minitv
            const isActive = checkJarvis(promotional, setting);
            if (isActive) {
              data = promotional;
              isActiveFrom = 'jarvis';
            }
          }
        }
        startloadingAssest(data, isActiveFrom, true);
      })
      .catch(error => dispatch(handleDataError(error)));
  };
}

export default function reducer(state = {}, action) {
  switch (action.type) {
    case RECIEVE_MINITV_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case SHOW_MINITV_PLAYER:
      return {
        ...state,
        showMiniTvPlayer: action.payload.showMiniTv,
      };
    case CLOSE_MINITV_PLAYER:
      return {
        ...state,
        isActiveFrom: action.payload.isActiveFrom,
      };
    case HANDLE_DATA_ERROR:
      return {
        ...state,
        isActiveFrom: action.payload.isActiveFrom,
        error: action.payload.error,
      };
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
